import { filters } from '@/config/data-tables/roleHeaderAndFilter';
import { createDataTableFilterStore } from '@/utils/store';

// Empty string or null can be set for text filter
// but for dropdown filter, please set to null

const defaultFilters = Object.fromEntries(filters.map((filter) => [filter.key, null]));

const defaultSortKey = 'name';
const defaultSortOrder = 'asc';

export const useRoleFilterStore = createDataTableFilterStore(
  'role-filters',
  defaultFilters,
  defaultSortKey,
  defaultSortOrder
);
